import { MutationTree } from 'vuex';
import * as MT from './mutationTypes';
import {
  Fund,
  Strategy,
  ProductType,
  PaginationMeta,
  OrganisationManager,
  FundFilters,
  FundRow,
  Currency
} from '../types';
import { IFundState } from './state';
import { PensionScheme } from '@/modules/pensionScheme/types';
import { SubFund } from '@/modules/subFund/types';

/*--------------------------------------------------/
 * Fund Mutations
 *--------------------------------------------------*/
export const FundMutations: IFundMutations = {
  [MT.SET_ORGANISATION_FUNDS]: (state: IFundState, funds: Fund[]) =>
    (state.organizationFunds = funds),
  [MT.SET_SELECTED_FUND]: (state: IFundState, fund: FundRow) =>
    (state.selectedFund = fund),
  [MT.SET_ORGANISATION_PENSION_SCHEMES]: (
    state: IFundState,
    pensionSchemes: PensionScheme[]
  ) => (state.pensionSchemes = pensionSchemes),
  [MT.SET_STRATEGIES]: (state: IFundState, strategies: Strategy[]) =>
    (state.strategies = strategies),
  [MT.SET_PRODUCT_TYPES]: (state: IFundState, productTypes: ProductType[]) =>
    (state.productTypes = productTypes),
  [MT.SET_FUNDS_PAGINATION_META]: (
    state: IFundState,
    paginationMeta: PaginationMeta
  ) => (state.paginationMeta = paginationMeta),
  [MT.SET_ORGANISATION_EXPOSED_FUNDS]: (state: IFundState, funds: Fund[]) =>
    (state.organizationExposedFunds = funds),
  [MT.SET_EXPOSED_FUNDS_PAGINATION_META]: (
    state: IFundState,
    paginationMeta: PaginationMeta
  ) => (state.exposedPaginationMeta = paginationMeta),
  [MT.SET_ORGANIZATION_SUB_FUNDS]: (state: IFundState, subFunds: SubFund[]) =>
    (state.organizationSubFunds = subFunds),
  [MT.SET_ORGANIZATION_MANAGERS]: (
    state: IFundState,
    organizationManagers: OrganisationManager[]
  ) => (state.organizationManagers = organizationManagers),
  [MT.SET_ALL_FUNDS_FILTERS]: (
    state: IFundState,
    allFundsFilters: FundFilters | null
  ) => (state.allFundsFilters = allFundsFilters),
  [MT.SET_EXPOSED_FUNDS_FILTERS]: (
    state: IFundState,
    exposedFundsFilters: FundFilters | null
  ) => (state.exposedFundsFilters = exposedFundsFilters)
};

/*--------------------------------------------------/
 * Fund Mutations Tree Interface
 *--------------------------------------------------*/
export interface IFundMutations extends MutationTree<IFundState> {
  [MT.SET_ORGANISATION_FUNDS](state: IFundState, funds: Fund[]): void;
  [MT.SET_SELECTED_FUND](state: IFundState, fund: FundRow): void;
  [MT.SET_ORGANISATION_PENSION_SCHEMES](
    state: IFundState,
    pensionSchemes: PensionScheme[]
  ): void;
  [MT.SET_STRATEGIES](state: IFundState, strategies: Strategy[]): void;
  [MT.SET_PRODUCT_TYPES](state: IFundState, productTypes: ProductType[]): void;
  [MT.SET_FUNDS_PAGINATION_META](
    state: IFundState,
    paginationMeta: PaginationMeta
  ): void;
  [MT.SET_ORGANISATION_EXPOSED_FUNDS](state: IFundState, funds: Fund[]): void;
  [MT.SET_EXPOSED_FUNDS_PAGINATION_META](
    state: IFundState,
    paginationMeta: PaginationMeta
  ): void;
  [MT.SET_ORGANIZATION_SUB_FUNDS](state: IFundState, subFunds: SubFund[]): void;
  [MT.SET_ORGANIZATION_MANAGERS](
    state: IFundState,
    organizationManagers: OrganisationManager[]
  ): void;
  [MT.SET_ALL_FUNDS_FILTERS](
    state: IFundState,
    allFundsFilters: FundFilters
  ): void;
  [MT.SET_EXPOSED_FUNDS_FILTERS](
    state: IFundState,
    exposedFundsFilters: FundFilters
  ): void;
}
